import { Uploader } from '../../UI/Dropzone/Uploader';
import './testiPhotos.css';
export const TestiPhotos = () => {
  return (
    <div>
      <div style={{ marginTop: '2%' }}>
        <h3 className="sywfh_r_subtitle">Share Your Moments</h3>
        <p className="sywf_r_content">
          You can upload any number of photos and up to 3 videos of your event and event flowers.
          The more the merrier! We recommend at least 10 images showcasing your flowers. Bonus for
          the flower statement shot!
        </p>
        <p className="sywf_r_content">
          *Videos must be limited in file size to under 500 MB or 1 minute in length. If longer,
          please upload to a third party site and add the link to the "About Your Event"
        </p>
        <Uploader key={'dropUploader'} />
      </div>
    </div>
  );
};
